// extracted by mini-css-extract-plugin
export default {"shift":"Shift_shift__8rhXX","placeHolderShimmer":"Shift_placeHolderShimmer__KtsvC"};